// Per-route SEO metadata (titles <=60 chars, descriptions <=155 chars),
// keyword-optimized for Google search. `category` (schema.org app type) is
// present only on app landing pages so the SEO component can emit
// SoftwareApplication JSON-LD. Keyed by the React Router pathname.
//
// The data lives in seoMeta.json so the React app AND the postbuild
// prerender script (scripts/prerender-heads.js) share one source of truth.

import seoMeta from './seoMeta.json';

export const ORIGIN = 'https://pandataps.com';

export default seoMeta;
